import React from 'react'
import { FooterConfig } from '../../constants'

const Footer = (props) => {
    let country = props.countryCode
    return (
        <footer id='footer' className='text-xs overflow-x-hidden'>
            <div className="svg text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                    <path fill="currentColor" fill-opacity="1" d="M0,224L48,213.3C96,203,192,181,288,186.7C384,192,480,224,576,218.7C672,213,768,171,864,170.7C960,171,1056,213,1152,208C1248,203,1344,149,1392,122.7L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
                </svg>
            </div>
            <div className="bg-primary p-4 text-light md:flex md:justify-between">
                <div className="footer-header md:w-1/2">
                    <div className="Lato-font">
                        <h1 className='text-lg font-bold selection:bg-white selection:text-primary'>Rudin Engineer</h1>
                        <p className='selection:bg-white selection:text-primary max-w-[80%]'>{ FooterConfig[country].quote }</p>
                    </div>
                    <div className="social-media">
                        {/* Social Media */}
                        <div className="social-media flex gap-2">
                            {
                                FooterConfig.sosmed.map((value, index) => (
                                    <div className='mt-2'>
                                        <a href={ value.url }>
                                            <img src={ require(`../../assets/icons/${value.icon}`) } alt={value.name} className='w-[14px] selection:bg-white selection:text-primary'/>
                                        </a>
                                    </div>
                                ))
                            }
                        </div>
                        {/* End Social Media */}
                    </div>
                </div>
                {/* Footer Link */}
                <div className="footer-link flex justify-between mt-4 md:w-1/2">
                {
                    FooterConfig.link.map((value, index) => (
                        <div>
                            <div>
                                <h1 className='text-sm font-semibold selection:bg-white selection:text-primary'>{ value.title }</h1>
                            </div>
                            <div className='flex flex-col justify-evenly gap-1 mt-1'>
                                {
                                    value.list.map((value, index) => (
                                        <a href={ value.url } className='nav-link text-xs transition duration-500 ease-in-out selection:bg-white selection:text-primary hover:text-secondary'>{ value.name }</a>
                                    ))
                                }
                            </div>
                        </div>
                    ))
                }
                </div>
                {/* End Footer Link */}
            </div>
            <div className="copyright bg-primary flex justify-center text-light py-4 md:text-sm">
                <span className='selection:bg-white selection:text-primary'>developed by <span className='font-bold text-teal-400 selection:bg-white selection:text-primary'>rudin engineer</span> with <a href='https://react.dev' className='font-bold text-teal-400 selection:bg-white selection:text-primary'>React JS</a></span>
            </div>
        </footer>
    )
}

export default Footer